import {inject, Injectable} from '@angular/core';
import {TableColumnCheckboxService} from "./table-column-checkbox.service";
import {ModalsService} from "../../../services/modals.service";
import {ErrorService} from "../../../services/error.service";

@Injectable({
  providedIn: 'root'
})
export class RecordTableOpenModalService {
  private tableColumnCheckBoxService: TableColumnCheckboxService = inject(TableColumnCheckboxService);
  private modalsService: ModalsService = inject(ModalsService);
  private errorService: ErrorService = inject(ErrorService);

  public async sendMassOffers(): Promise<void> {
    const bloggerIds = this.tableColumnCheckBoxService.getColumnCheckboxStateIds();
    if (!bloggerIds.length) {
      this.errorService.showErrorMessage('Надо выбрать блогера(ов)');
      return;
    }

    await this.modalsService.openBloggerMassOffer(bloggerIds);
  }

  public async openCreateBloggerGroup(): Promise<void> {
    const bloggerIds = this.tableColumnCheckBoxService.getColumnCheckboxStateIds();
    await this.modalsService.openBloggerGroupsModal<Array<number>>(bloggerIds, 'newBloggerGroups');
  }
}
